import { gqlRequest } from '@mdvip/shared/lib/graphql-client';
import { MyNextPaymentDueDocument, type MyNextPaymentDueQuery } from '@/graphql/generated/graphql';

export type NextPaymentDue = MyNextPaymentDueQuery['myNextPaymentDue'];

export async function requestNextPaymentDue(): Promise<NextPaymentDue> {
  const data = await gqlRequest(MyNextPaymentDueDocument);
  return data.myNextPaymentDue;
}
